import React from "react";
import Alert from "@material-ui/lab/Alert";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
/**
 *
 * @param {String} tipo Valores Posibles "error" || "info"
 * @returns
 */
function APIMensajeMUI({
    showMensaje = false,
    setShowMensaje,
    msg,
    mt = null,
    mb = null,
    tipo = "error",
}) {
    const [msgInterno, setMsgInterno] = React.useState("Ha ocurrido un error");

    React.useEffect(() => {
        if (tipo !== "error" && tipo !== "info") {
            throw "tipo debe ser 'error' o 'info' en APIMensajeMUI";
        }
    }, []);

    React.useEffect(() => {
        if (Boolean(msg)) {
            setMsgInterno(msg);
        }
    }, [msg]);

    const getStyles = () => {
        let styles = {};
        if (mt !== null) {
            styles = {
                ...styles,
                marginTop: mt,
            };
        }
        if (mb !== null) {
            styles = {
                ...styles,
                marginBottom: mb,
            };
        }
        return styles;
    };

    const AlertCondicional = () => {
        if (tipo === "error") {
            return (
                <Alert severity="error" style={getStyles()} action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            setShowMensaje(false);
                        }}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                    sx={{ mb: 2 }}
                >
                    <strong>ERROR: </strong>
                    {msgInterno}
                </Alert>
            );
        } else if (tipo === "info") {
            return (
                <Alert severity="info" style={getStyles()}>
                    {msgInterno}
                </Alert>
            );
        }
    };

    return (
        <>
            {showMensaje && <AlertCondicional />}
        </>
    );
}

export default APIMensajeMUI;
